<template>
    <h6>
        <b class="text-primary">{{ $t("start.subtitle") }}</b>
    </h6>
    <hr>
</template>
